import { listFields, VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { FIELDS_TYPES } from "../../../api/config/type.config";

export const listContentTypeFields = {
  'Column': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING
  },
  'VPOAutoEndQuestionary': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Month: FIELDS_TYPES.STRING,
    Year: FIELDS_TYPES.STRING,
    AutoEndDate: FIELDS_TYPES.DATE,
    AutoCopyDate: FIELDS_TYPES.DATE,
    StartDate: FIELDS_TYPES.DATE
  },
  'ColumnFilter': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING
  },
  'ColumnAddAction': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING
  },
  'Directory': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Subdivisions: FIELDS_TYPES.MULTI_LOOKUP,
    FileRef: FIELDS_TYPES.STRING
  },
  'GroupSelect': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Subdivisions: FIELDS_TYPES.MULTI_LOOKUP
  },
  'GroupAddAction': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Subdivisions: FIELDS_TYPES.MULTI_LOOKUP
  },
  'GroupRequirements': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP
  },
  'ColumnBlockFilter': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP
  },
  'ColumnBlockAddAction': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP
  },
  'DemandFilter': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
  },
  'DemandAddAction': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    Factory: FIELDS_TYPES.MULTI_LOOKUP,
    Process: FIELDS_TYPES.LOOKUP,
  },
  'VPOsubdivision': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    TypeSubdivision: FIELDS_TYPES.LOOKUP,
    VPOgroup: FIELDS_TYPES.MULTI_LOOKUP,
    SortNumber: FIELDS_TYPES.STRING
  },
  'VPOfactory': {
    ID: FIELDS_TYPES.ID,
    Title: FIELDS_TYPES.STRING,
    VPOgroup: FIELDS_TYPES.MULTI_LOOKUP
  },
  'VPOprocess': {
    Title: FIELDS_TYPES.STRING,
    ID: FIELDS_TYPES.ID,
    BlockContent: FIELDS_TYPES.STRING,
    BlockContentTitle: FIELDS_TYPES.STRING,
  },
  [VPORequirementsConditionsListName]: listFields[VPORequirementsConditionsListName],
  [VPOStatusQuestionnaireListName]: listFields[VPOStatusQuestionnaireListName],
  'VPOStatusQuestionnaireAll': listFields[VPOStatusQuestionnaireListName],
}

export const idsGroups: any = {
  'BOP': {
    22: {
      groupId: 24
    },
    30: {
      groupId: 31
    },
    499: {
      groupId: 501
    },
    500: {
      groupId: 841
    },
    2021: {
      groupId: 2022
    },
    2590: {
      groupId: 2591
    },
    3938: {
      groupId: 5290
    }
  },
  'SOP': {
    22: {
      groupId: 27
    },
  },
  'VOP': {
    22: {
      groupId: 1279
    },
    30: {
      groupId: 1566
    },
    499: {
      groupId: 502
    },
    500: {
      groupId: 842
    },
    2021: {
      groupId: 2023
    },
    2590: {
      groupId: 2592
    },
    3938: {
      groupId: 3939
    }
  }
}

export const ContentTypeIdColumn = '0x012000B27514BD011F154B88D7143178D6F395';
export const ContentTypeIdDirectory = '0x01200000B9E43B99A62343A9D89900FADD3ADE';
export const ContentTypeIdGroupRequirement = '0x012000BADB9EA68A6B6F44B5C34C6DE1C497CA';
export const ContentTypeIdRequirement = '0x0100867E0145492A914FA6335394438EBE21';
export const ContentTypeIdRequirementCondition = '0x010071F3BEA334D24D48A39185B03AB8A641';
